(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dn-apparel-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dn-apparel-product')) {
    customElements.define('dn-apparel-product', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        try { this.variants = JSON.parse(this.querySelector('[data-variants]').textContent); }
        catch (_) { return; }
        this.select = this.querySelector('[data-variant-select]');
        this.groups = Array.from(this.querySelectorAll('[data-option-group]'));
        this.slider = this.querySelector('[data-gallery]');
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.dialog = this.querySelector('[data-zoom-dialog]');
        this.galleryIndex = 0;
        const initial = this.variants.find((variant) => String(variant.id) === this.dataset.initialVariant);
        if (!initial) return;
        this.groups.forEach((group) => {
          group.querySelectorAll('[data-option-input]').forEach((input) => { input.checked = input.value === initial.options[Number(group.dataset.optionIndex)]; });
        });
        this.select.value = String(initial.id);
        this.querySelector('[data-native-picker]').hidden = true;
        this.querySelector('[data-option-pickers]').hidden = false;
        this.querySelector('[data-gallery-controls]')?.removeAttribute('hidden');
        this.updateAvailability(initial.options);
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-option-input]')) this.updateVariant();
        }, options);
        this.addEventListener('click', (event) => {
          const image = event.target.closest('[data-zoom]');
          if (image && this.dialog && typeof this.dialog.showModal === 'function') { event.preventDefault(); this.openZoom(image); }
          if (event.target.closest('[data-zoom-close]')) this.dialog.close();
          if (event.target.closest('[data-gallery-previous]')) this.goToImage(this.galleryIndex - 1);
          if (event.target.closest('[data-gallery-next]')) this.goToImage(this.galleryIndex + 1);
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
        }, options);
        this.slider?.addEventListener('scroll', () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.updateGalleryIndex(); });
        }, { ...options, passive: true });
        this.dialog?.addEventListener('close', () => this.restoreZoomFocus(), options);
        this.dialog?.addEventListener('cancel', (event) => { event.preventDefault(); this.dialog.close(); }, options);
        this.updateGalleryIndex();
      }

      disconnectedCallback() {
        this.controller?.abort();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        if (this.dialog?.open) this.dialog.close();
        this.restoreZoomFocus();
      }

      selectedOptions() {
        const values = [];
        this.groups.forEach((group) => { values[Number(group.dataset.optionIndex)] = group.querySelector('[data-option-input]:checked')?.value; });
        return values;
      }

      updateAvailability(values) {
        this.groups.forEach((group) => {
          const index = Number(group.dataset.optionIndex);
          const selected = group.querySelector('[data-selected-value]');
          if (selected) selected.textContent = values[index] || '';
          group.querySelectorAll('[data-option-input]').forEach((input) => {
            const available = this.variants.some((variant) => variant.available && variant.options.every((value, position) => value === (position === index ? input.value : values[position])));
            input.closest('.dn-apparel__option-value').dataset.unavailable = String(!available);
            input.nextElementSibling.querySelector('[data-option-status]').textContent = available ? '' : ` — ${this.dataset.soldOutLabel}`;
          });
        });
      }

      updateVariant() {
        const values = this.selectedOptions();
        const variant = this.variants.find((item) => item.options.every((value, index) => value === values[index]));
        this.updateAvailability(values);
        const submit = this.querySelector('.dn-apparel__submit');
        const available = Boolean(variant?.available);
        submit.disabled = !available;
        this.select.value = variant ? String(variant.id) : '';
        this.querySelector('[data-add-text]').textContent = !variant ? this.dataset.unavailableLabel : available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        this.querySelector('[data-availability]').textContent = !variant ? this.dataset.unavailableLabel : available ? this.dataset.availableLabel : this.dataset.soldOutLabel;
        this.querySelector('[data-price-wrap]').hidden = !variant;
        if (!variant) return;
        this.querySelector('[data-price]').textContent = variant.price;
        const compare = this.querySelector('[data-compare]');
        if (compare) {
          compare.textContent = variant.compare;
          this.querySelector('[data-compare-wrap]').hidden = !variant.on_sale;
        }
        const quantity = this.querySelector('[name="quantity"]');
        const minimum = Number(variant.quantity.min) || 1;
        const step = Number(variant.quantity.step) || 1;
        quantity.min = minimum;
        quantity.step = step;
        if (variant.quantity.max !== null && variant.quantity.max !== undefined) quantity.max = variant.quantity.max;
        else quantity.removeAttribute('max');
        let next = minimum + Math.max(0, Math.ceil(((Number(quantity.value) || minimum) - minimum) / step)) * step;
        if (quantity.max) next = Math.min(next, minimum + Math.floor((Number(quantity.max) - minimum) / step) * step);
        quantity.value = next;
        if (variant.image && this.slides[0]) {
          const lead = this.slides[0];
          const image = lead.querySelector('img');
          image.removeAttribute('srcset');
          image.src = variant.image.src;
          image.alt = variant.image.alt || '';
          lead.href = variant.image.zoom;
          lead.dataset.imageId = String(variant.image.id);
          lead.setAttribute('aria-label', `${this.dialog.getAttribute('aria-label')} — ${variant.image.alt || ''}`);
          this.goToImage(0);
        }
        if (!window.Shopify?.designMode) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(variant.id));
          window.history.replaceState({}, '', url);
        }
      }

      goToImage(index) {
        const next = Math.max(0, Math.min(index, this.slides.length - 1));
        const slide = this.slides[next];
        if (!slide) return;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.slider.scrollTo({ left: slide.offsetLeft, behavior: motion });
        this.galleryIndex = next;
        this.updateGalleryControls();
      }

      updateGalleryIndex() {
        if (!this.slides.length) return;
        let closest = 0;
        this.slides.forEach((slide, index) => {
          if (Math.abs(slide.offsetLeft - this.slider.scrollLeft) < Math.abs(this.slides[closest].offsetLeft - this.slider.scrollLeft)) closest = index;
        });
        this.galleryIndex = closest;
        this.updateGalleryControls();
      }

      updateGalleryControls() {
        const count = this.querySelector('[data-gallery-index]');
        if (count) count.textContent = String(this.galleryIndex + 1);
        const previous = this.querySelector('[data-gallery-previous]');
        const next = this.querySelector('[data-gallery-next]');
        if (previous) previous.disabled = this.galleryIndex === 0;
        if (next) next.disabled = this.galleryIndex >= this.slides.length - 1;
      }

      openZoom(trigger) {
        const image = trigger.querySelector('img');
        const enlarged = this.dialog.querySelector('img');
        if (!image || !enlarged) return;
        enlarged.removeAttribute('srcset');
        enlarged.src = trigger.href;
        enlarged.alt = image.alt;
        this.zoomTrigger = trigger;
        this.scrollState = { body: document.body.style.overflow, root: document.documentElement.style.overflow };
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        this.querySelector('[data-zoom-close]').focus({ preventScroll: true });
      }

      restoreZoomFocus() {
        if (!this.scrollState) return;
        document.body.style.overflow = this.scrollState.body;
        document.documentElement.style.overflow = this.scrollState.root;
        this.scrollState = null;
        if (this.zoomTrigger?.isConnected) this.zoomTrigger.focus({ preventScroll: true });
        this.zoomTrigger = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dn-cart-drawer"]) return;
  try {
    
  if (!customElements.get('dn-cart-drawer')) {
    customElements.define('dn-cart-drawer', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function' || !window.fetch) return;
        this.sectionId = this.dataset.sectionId || 'dn-cart-drawer';
        const root = new URL(this.dataset.rootUrl || window.Shopify?.routes?.root || '/', window.location.origin);
        this.root = root.origin === window.location.origin ? root.pathname : '/';
        if (!this.root.endsWith('/')) this.root += '/';
        this.busy = false;
        this.messages = {
          loading: this.dataset.loadingLabel,
          adding: this.dataset.addingLabel,
          updating: this.dataset.updatingLabel,
          added: this.dataset.addedLabel,
          updated: this.dataset.updatedLabel,
          error: this.dataset.errorLabel,
          uncertain: this.dataset.uncertainLabel,
          addedRefresh: this.dataset.addedRefreshLabel,
          quantityError: this.dataset.quantityError
        };
        const options = { signal: this.controller.signal };
        document.addEventListener('submit', (event) => {
          const form = event.target;
          if (this.cartPageDirty && form.closest?.('[data-dn-cart-page]')) { event.preventDefault(); return; }
          if (event.defaultPrevented || !form.matches?.('.dn-product__form')) return;
          event.preventDefault();
          if (this.busy || !form.reportValidity()) return;
          this.add(form, event.submitter);
        }, { ...options, capture: true });
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest?.('[data-dn-cart-open], .dn-frame__cart');
          if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.open(trigger);
        }, options);
        this.addEventListener('click', (event) => this.handleClick(event), options);
        this.addEventListener('change', (event) => {
          if (event.target.matches?.('[data-cart-quantity]')) this.updateInput(event.target);
        }, options);
        this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); }, options);
        this.dialog.addEventListener('close', () => this.afterClose(), options);
        this.readInitialCart();
      }

      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.afterClose();
      }

      readInitialCart() {
        try {
          this.cart = JSON.parse(this.querySelector('[data-cart-json]').textContent);
          this.updateCounts(this.cart.item_count);
        } catch (_) {
          this.updateCounts(Number(this.querySelector('[data-cart-content]')?.dataset.itemCount) || 0);
        }
      }

      open(trigger = document.activeElement, { refresh = true } = {}) {
        if (!this.dialog?.open) {
          this.returnFocus = trigger;
          this.previousScroll = { body: document.body.style.overflow, root: document.documentElement.style.overflow };
          document.body.style.overflow = 'hidden';
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
          this.querySelector('[data-cart-close]')?.focus({ preventScroll: true });
        }
        return refresh ? this.refresh() : Promise.resolve(this.cart);
      }

      close() {
        if (this.dialog?.open) this.dialog.close();
      }

      afterClose() {
        if (!this.previousScroll) return;
        document.body.style.overflow = this.previousScroll.body;
        document.documentElement.style.overflow = this.previousScroll.root;
        this.previousScroll = null;
        if (this.returnFocus?.isConnected) {
          if (this.returnFocus.disabled) this.pendingReturnFocus = this.returnFocus;
          else this.returnFocus.focus({ preventScroll: true });
        }
        this.returnFocus = null;
        if (this.cartPageDirty) {
          if (this.busy) this.reloadWhenSettled = true;
          else window.location.reload();
        }
      }

      handleClick(event) {
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
          return;
        }
        if (event.target.closest?.('[data-cart-close]')) { this.close(); return; }
        if (event.target.closest?.('[data-cart-refresh]')) { this.refresh(); return; }
        const button = event.target.closest?.('[data-line-action]');
        if (!button || this.busy || button.disabled) return;
        const line = button.closest('[data-line-key]');
        const input = line.querySelector('[data-cart-quantity]');
        const current = Number(input.dataset.currentQuantity);
        const step = Number(input.step) || 1;
        let quantity = current;
        if (button.dataset.lineAction === 'remove') quantity = 0;
        if (button.dataset.lineAction === 'increase') quantity += step;
        if (button.dataset.lineAction === 'decrease') quantity -= step;
        this.change(line.dataset.lineKey, quantity);
      }

      updateInput(input) {
        const current = Number(input.dataset.currentQuantity);
        if (this.busy) { input.value = current; return; }
        const quantity = Number(input.value);
        const minimum = Number(input.dataset.minimum) || 1;
        const step = Number(input.step) || 1;
        const maximum = input.max ? Number(input.max) : Infinity;
        if (input.value.trim() === '' || !Number.isInteger(quantity) || quantity < 0 || quantity > maximum || (quantity !== 0 && (quantity < minimum || (quantity - minimum) % step !== 0))) {
          input.value = current;
          this.showError(this.messages.quantityError, input.closest('[data-line-key]').dataset.lineKey);
          return;
        }
        if (quantity !== current) this.change(input.closest('[data-line-key]').dataset.lineKey, quantity);
      }

      lockForm(form) {
        const previousBusy = form.getAttribute('aria-busy');
        const controls = Array.from(form.querySelectorAll('input, select, textarea, button')).map((control) => [control, control.disabled]);
        form.setAttribute('aria-busy', 'true');
        controls.forEach(([control]) => { control.disabled = true; });
        return () => {
          if (previousBusy === null) form.removeAttribute('aria-busy');
          else form.setAttribute('aria-busy', previousBusy);
          controls.forEach(([control, disabled]) => { control.disabled = disabled; });
          this.restoreReturnFocus();
        };
      }

      add(form, trigger) {
        if (this.busy) return this.operation;
        const body = new FormData(form);
        body.set('sections', this.sectionId);
        body.set('sections_url', this.root);
        const unlock = this.lockForm(form);
        this.open(trigger || form.querySelector('[type="submit"]'), { refresh: false });
        return this.run(async () => {
          this.markCartPageDirty();
          let response;
          try {
            response = await this.requestJSON(`${this.root}cart/add.js`, { method: 'POST', body });
          } catch (error) {
            await this.recover(error);
            throw error;
          }
          try {
            const cart = await this.applyResponse(response);
            this.setStatus(this.messages.added);
            return cart;
          } catch (error) {
            error.userMessage = this.messages.addedRefresh;
            throw error;
          }
        }, this.messages.adding).finally(unlock);
      }

      change(key, quantity) {
        if (this.busy) return this.operation;
        return this.run(async () => {
          this.markCartPageDirty();
          let response;
          try {
            response = await this.requestJSON(`${this.root}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity, sections: this.sectionId, sections_url: this.root })
            });
          } catch (error) {
            error.lineKey = key;
            await this.recover(error);
            throw error;
          }
          const cart = await this.applyResponse(response);
          this.setStatus(this.messages.updated);
          return cart;
        }, this.messages.updating);
      }

      refresh() {
        if (this.busy) return this.operation;
        return this.run(async () => {
          const cart = await this.fetchContent();
          this.setStatus('');
          return cart;
        }, this.messages.loading);
      }

      run(task, message) {
        if (this.busy) return this.operation;
        this.busy = true;
        const active = document.activeElement;
        if (this.querySelector('[data-cart-content]')?.contains(active)) this.focusAfterRender = { key: active.closest('[data-line-key]')?.dataset.lineKey, target: active.dataset.focus };
        this.showError('');
        this.setBusy(true);
        this.setStatus(message);
        this.operation = (async () => {
          try {
            return await task();
          } catch (error) {
            this.setStatus('');
            this.showError(error.userMessage || this.messages.error, error.lineKey);
            return null;
          } finally {
            this.busy = false;
            this.setBusy(false);
            this.restoreContentFocus();
            if (this.cartPageDirty && this.reloadWhenSettled) window.location.reload();
          }
        })();
        return this.operation;
      }

      async requestJSON(url, options = {}) {
        let response;
        try {
          response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, headers: { Accept: 'application/json', ...options.headers } });
        } catch (error) {
          error.userMessage = this.messages.uncertain;
          throw error;
        }
        let data;
        try { data = await response.json(); }
        catch (_) {
          const error = new Error('Invalid cart response');
          error.userMessage = this.messages.uncertain;
          throw error;
        }
        if (!data || typeof data !== 'object') {
          const error = new Error('Invalid cart data');
          error.userMessage = this.messages.uncertain;
          throw error;
        }
        if (!response.ok || Number(data.status) >= 400) {
          const error = new Error('Cart request failed');
          const strings = (value) => typeof value === 'string' ? value : Array.isArray(value) ? value.map(strings).join(' ') : value && typeof value === 'object' ? Object.values(value).map(strings).join(' ') : '';
          error.userMessage = strings(data.description || data.errors || data.message).slice(0, 600) || this.messages.error;
          throw error;
        }
        return data;
      }

      async recover(error) {
        try { await this.fetchContent(); }
        catch (_) { if (!error.userMessage) error.userMessage = this.messages.uncertain; }
      }

      async applyResponse(response) {
        const html = response.sections?.[this.sectionId];
        if (typeof html === 'string') {
          try { return this.renderContent(html); }
          catch (_) { return this.fetchContent(); }
        }
        return this.fetchContent();
      }

      async fetchContent() {
        const url = new URL(this.root, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);
        const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Cart section unavailable');
        return this.renderContent(await response.text());
      }

      renderContent(html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = parsed.querySelector('dn-cart-drawer [data-cart-content]');
        const json = fresh?.querySelector('[data-cart-json]');
        if (!fresh || !json) throw new Error('Cart section missing');
        const cart = JSON.parse(json.textContent);
        if (!Number.isFinite(cart.item_count) || !Array.isArray(cart.items)) throw new Error('Cart data missing');
        const content = this.querySelector('[data-cart-content]');
        const active = document.activeElement;
        if (this.dialog.open && content.contains(active)) {
          this.focusAfterRender = { key: active.closest('[data-line-key]')?.dataset.lineKey, target: active.dataset.focus };
        }
        content.replaceChildren(...Array.from(fresh.childNodes));
        content.dataset.itemCount = String(cart.item_count);
        this.cart = cart;
        this.updateCounts(cart.item_count);
        this.setBusy(this.busy);
        document.dispatchEvent(new CustomEvent('dn:cart-updated', { detail: { cart } }));
        return cart;
      }

      updateCounts(count) {
        if (!Number.isFinite(Number(count))) return;
        document.querySelectorAll('.dn-frame__cart span, [data-dn-cart-count]').forEach((node) => { node.textContent = String(count); });
        this.querySelector('[data-drawer-count]').textContent = String(count);
      }

      markCartPageDirty() {
        const page = document.querySelector('[data-dn-cart-page]');
        if (!page) return;
        this.cartPageDirty = true;
        page.setAttribute('aria-busy', 'true');
        page.inert = true;
        page.querySelectorAll('form input, form button, form select, form textarea').forEach((control) => { control.disabled = true; });
      }

      restoreReturnFocus() {
        const trigger = this.pendingReturnFocus;
        this.pendingReturnFocus = null;
        if (!trigger?.isConnected || trigger.disabled || this.dialog.open) return;
        if (document.activeElement === document.body || document.activeElement === this.dialog) trigger.focus({ preventScroll: true });
      }

      setBusy(busy) {
        const content = this.querySelector('[data-cart-content]');
        content?.setAttribute('aria-busy', String(busy));
        this.querySelectorAll('[data-cart-content] button, [data-cart-content] input, [data-cart-refresh]').forEach((control) => {
          if (busy) {
            if (!control.hasAttribute('data-dn-was-disabled')) control.dataset.dnWasDisabled = String(control.disabled);
            control.disabled = true;
          } else if (control.hasAttribute('data-dn-was-disabled')) {
            control.disabled = control.dataset.dnWasDisabled === 'true';
            delete control.dataset.dnWasDisabled;
          }
        });
      }

      setStatus(message) {
        this.querySelector('[data-cart-status]').textContent = message || '';
      }

      showError(message, key) {
        this.querySelector('[data-cart-error]').hidden = !message;
        this.querySelector('[data-cart-error-message]').textContent = message || '';
        if (!message) return;
        const line = Array.from(this.querySelectorAll('[data-line-key]')).find((item) => item.dataset.lineKey === key);
        const target = line?.querySelector('[data-line-error]');
        if (target) { target.textContent = message; target.hidden = false; }
      }

      restoreContentFocus() {
        if (!this.focusAfterRender) return;
        const { key, target } = this.focusAfterRender;
        this.focusAfterRender = null;
        if (!this.dialog.open) return;
        const region = key ? Array.from(this.querySelectorAll('[data-line-key]')).find((item) => item.dataset.lineKey === key) : this.querySelector('[data-cart-content]');
        const control = Array.from(region?.querySelectorAll('[data-focus]') || []).find((item) => item.dataset.focus === target && !item.disabled);
        (control || this.querySelector('[data-cart-close]'))?.focus({ preventScroll: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dn-cosmic-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dn-cosmic-product')) {
    customElements.define('dn-cosmic-product', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        if (this.stickyFrame) cancelAnimationFrame(this.stickyFrame);
        this.stickyFrame = null;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        try { this.variants = JSON.parse(this.querySelector('[data-variants]').textContent); }
        catch (_) { return; }
        this.select = this.querySelector('[data-variant-select]');
        this.groups = Array.from(this.querySelectorAll('[data-option-group]'));
        this.slider = this.querySelector('[data-gallery]');
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        this.dialog = this.querySelector('[data-zoom-dialog]');
        this.purchase = this.querySelector('[data-purchase]');
        this.sticky = this.querySelector('[data-sticky]');
        this.galleryIndex = 0;
        const initial = this.variants.find((variant) => String(variant.id) === this.dataset.initialVariant);
        if (!initial || !this.select) return;
        this.groups.forEach((group) => {
          group.querySelectorAll('[data-option-input]').forEach((input) => { input.checked = input.value === initial.options[Number(group.dataset.optionIndex)]; });
        });
        this.select.value = String(initial.id);
        this.querySelector('[data-native-picker]').hidden = true;
        this.querySelector('[data-option-pickers]').hidden = this.groups.length === 0;
        this.querySelector('[data-gallery-controls]')?.removeAttribute('hidden');
        this.querySelector('[data-thumbnails]')?.removeAttribute('hidden');
        this.updateAvailability(initial.options);
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-option-input]')) this.updateVariant();
        }, options);
        this.addEventListener('click', (event) => {
          const image = event.target.closest('[data-zoom]');
          if (image && this.dialog && typeof this.dialog.showModal === 'function') { event.preventDefault(); this.openZoom(image); }
          if (event.target.closest('[data-zoom-close]')) this.dialog.close();
          if (event.target.closest('[data-gallery-previous]')) this.goToImage(this.galleryIndex - 1);
          if (event.target.closest('[data-gallery-next]')) this.goToImage(this.galleryIndex + 1);
          const thumbnail = event.target.closest('[data-gallery-thumb]');
          if (thumbnail) this.goToImage(Number(thumbnail.dataset.galleryThumb));
          if (event.target.closest('[data-options-link]') && this.purchase) {
            event.preventDefault();
            this.purchase.scrollIntoView({ behavior: this.motion(), block: 'start' });
            this.purchase.focus({ preventScroll: true });
          }
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
        }, options);
        this.slider?.addEventListener('scroll', () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.updateGalleryIndex(); });
        }, { ...options, passive: true });
        this.dialog?.addEventListener('close', () => this.restoreZoomFocus(), options);
        this.dialog?.addEventListener('cancel', (event) => { event.preventDefault(); this.dialog.close(); }, options);
        if (this.sticky && this.purchase) {
          const queueStickyUpdate = () => {
            if (this.stickyFrame) return;
            this.stickyFrame = requestAnimationFrame(() => {
              this.stickyFrame = null;
              this.updateSticky();
            });
          };
          window.addEventListener('scroll', queueStickyUpdate, { ...options, passive: true });
          window.addEventListener('resize', queueStickyUpdate, options);
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(() => this.updateSticky());
            this.observer.observe(this.purchase);
          }
          this.updateSticky();
        }
        this.updateGalleryIndex();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        if (this.stickyFrame) cancelAnimationFrame(this.stickyFrame);
        this.scrollFrame = null;
        this.stickyFrame = null;
        if (this.dialog?.open) this.dialog.close();
        this.restoreZoomFocus();
      }

      updateSticky() {
        if (this.sticky && this.purchase) this.sticky.hidden = this.purchase.getBoundingClientRect().bottom > 0;
      }

      selectedOptions() {
        const values = [];
        this.groups.forEach((group) => { values[Number(group.dataset.optionIndex)] = group.querySelector('[data-option-input]:checked')?.value; });
        return values;
      }

      updateAvailability(values) {
        this.groups.forEach((group) => {
          const index = Number(group.dataset.optionIndex);
          const selected = group.querySelector('[data-selected-value]');
          if (selected) selected.textContent = values[index] || '';
          group.querySelectorAll('[data-option-input]').forEach((input) => {
            const available = this.variants.some((variant) => variant.available && variant.options.every((value, position) => value === (position === index ? input.value : values[position])));
            input.closest('.dn-cosmic__option-value').dataset.unavailable = String(!available);
            input.nextElementSibling.querySelector('[data-option-status]').textContent = available ? '' : ` — ${this.dataset.soldOutLabel}`;
          });
        });
      }

      updateVariant() {
        const values = this.selectedOptions();
        const variant = this.groups.length ? this.variants.find((item) => item.options.every((value, index) => value === values[index])) : this.variants.find((item) => String(item.id) === this.dataset.initialVariant);
        this.updateAvailability(values);
        const available = Boolean(variant?.available);
        this.querySelector('.dn-cosmic__submit').disabled = !available;
        this.select.value = variant ? String(variant.id) : '';
        this.querySelector('[data-add-text]').textContent = !variant ? this.dataset.unavailableLabel : available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        this.querySelector('[data-availability]').textContent = !variant ? this.dataset.unavailableLabel : available ? this.dataset.availableLabel : this.dataset.soldOutLabel;
        this.querySelector('[data-price-wrap]').hidden = !variant;
        const stickyPrice = this.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = variant ? variant.price : this.dataset.unavailableLabel;
        if (!variant) {
          this.updateVariantUrl(null);
          return;
        }
        this.querySelector('[data-price]').textContent = variant.price;
        const compare = this.querySelector('[data-compare]');
        if (compare) {
          compare.textContent = variant.compare;
          this.querySelector('[data-compare-wrap]').hidden = !variant.on_sale;
        }
        const quantity = this.querySelector('[name="quantity"]');
        const minimum = Number(variant.quantity.min) || 1;
        const step = Number(variant.quantity.step) || 1;
        quantity.min = minimum;
        quantity.step = step;
        if (variant.quantity.max !== null && variant.quantity.max !== undefined) quantity.max = variant.quantity.max;
        else quantity.removeAttribute('max');
        let next = minimum + Math.max(0, Math.ceil(((Number(quantity.value) || minimum) - minimum) / step)) * step;
        if (quantity.max) next = Math.min(next, minimum + Math.floor((Number(quantity.max) - minimum) / step) * step);
        quantity.value = next;
        if (variant.image && this.slides.length) this.showVariantImage(variant.image);
        this.updateVariantUrl(variant.id);
      }

      updateVariantUrl(id) {
        if (window.Shopify?.designMode) return;
        const url = new URL(window.location.href);
        if (id) url.searchParams.set('variant', String(id));
        else url.searchParams.delete('variant');
        window.history.replaceState({}, '', url);
      }

      showVariantImage(media) {
        const existing = this.slides.findIndex((slide) => slide.dataset.imageId === String(media.id));
        if (existing !== -1) {
          this.goToImage(existing);
          return;
        }
        const lead = this.slides[0];
        const image = lead.querySelector('img');
        if (!image) return;
        image.removeAttribute('srcset');
        image.src = media.src;
        image.alt = media.alt || '';
        lead.href = media.zoom;
        lead.dataset.imageId = String(media.id);
        lead.setAttribute('aria-label', `${this.dataset.zoomLabel} — ${media.alt || ''}`);
        const thumbnail = this.thumbnails[0]?.querySelector('img');
        if (thumbnail) {
          thumbnail.removeAttribute('srcset');
          thumbnail.src = media.src;
        }
        this.goToImage(0);
      }

      motion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }

      goToImage(index) {
        const next = Math.max(0, Math.min(index, this.slides.length - 1));
        const slide = this.slides[next];
        if (!slide) return;
        this.slider.scrollTo({ left: slide.offsetLeft, behavior: this.motion() });
        this.galleryIndex = next;
        this.updateGalleryControls();
      }

      updateGalleryIndex() {
        if (!this.slides.length) return;
        let closest = 0;
        this.slides.forEach((slide, index) => {
          if (Math.abs(slide.offsetLeft - this.slider.scrollLeft) < Math.abs(this.slides[closest].offsetLeft - this.slider.scrollLeft)) closest = index;
        });
        this.galleryIndex = closest;
        this.updateGalleryControls();
      }

      updateGalleryControls() {
        const count = this.querySelector('[data-gallery-index]');
        if (count) count.textContent = String(this.galleryIndex + 1);
        const previous = this.querySelector('[data-gallery-previous]');
        const next = this.querySelector('[data-gallery-next]');
        if (previous) previous.disabled = this.galleryIndex === 0;
        if (next) next.disabled = this.galleryIndex >= this.slides.length - 1;
        this.slides.forEach((slide, index) => { slide.tabIndex = index === this.galleryIndex ? 0 : -1; });
        this.thumbnails.forEach((thumbnail, index) => { thumbnail.setAttribute('aria-current', String(index === this.galleryIndex)); });
      }

      openZoom(trigger) {
        const image = trigger.querySelector('img');
        const enlarged = this.dialog.querySelector('img');
        if (!image || !enlarged || this.dialog.open) return;
        enlarged.removeAttribute('srcset');
        enlarged.src = trigger.href;
        enlarged.alt = image.alt;
        this.zoomTrigger = trigger;
        this.scrollState = { body: document.body.style.overflow, root: document.documentElement.style.overflow };
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        this.querySelector('[data-zoom-close]').focus({ preventScroll: true });
      }

      restoreZoomFocus() {
        if (!this.scrollState) return;
        document.body.style.overflow = this.scrollState.body;
        document.documentElement.style.overflow = this.scrollState.root;
        this.scrollState = null;
        if (this.zoomTrigger?.isConnected) this.zoomTrigger.focus({ preventScroll: true });
        this.zoomTrigger = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dn-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dn-product')) {
    customElements.define('dn-product', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelectorAll('[data-image-src]').forEach((button) => {
          button.addEventListener('click', () => this.selectImage(button), options);
        });
        this.querySelector('[data-variant-select]')?.addEventListener('change', (event) => {
          this.selectVariant(event.target.selectedOptions[0]);
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      selectImage(button) {
        const image = this.querySelector('.dn-product__main-image');
        if (!image || image.tagName !== 'IMG') return;
        image.removeAttribute('srcset');
        image.src = button.dataset.imageSrc;
        image.alt = button.dataset.imageAlt || '';
        this.querySelectorAll('[data-image-src]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
      }

      selectVariant(option) {
        if (!option) return;
        const available = option.dataset.available === 'true';
        const submit = this.querySelector('[name="add"]');
        submit.disabled = !available;
        this.querySelector('[data-add-text]').textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        this.querySelector('[data-price]').textContent = option.dataset.price;
        this.querySelector('[data-compare]').textContent = option.dataset.compare;
        this.querySelector('[data-compare-wrap]').hidden = option.dataset.onSale !== 'true';
        const quantity = this.querySelector('[name="quantity"]');
        const minimum = Number(option.dataset.quantityMin) || 1;
        const step = Number(option.dataset.quantityStep) || 1;
        quantity.min = minimum;
        quantity.step = step;
        if (option.dataset.quantityMax) quantity.max = option.dataset.quantityMax;
        else quantity.removeAttribute('max');
        const previous = Number(quantity.value) || minimum;
        let next = minimum + Math.max(0, Math.ceil((previous - minimum) / step)) * step;
        if (quantity.max) {
          const maximum = Number(quantity.max);
          next = Math.min(next, minimum + Math.floor((maximum - minimum) / step) * step);
        }
        quantity.value = next;
        const thumbnail = Array.from(this.querySelectorAll('[data-image-src]')).find((item) => item.dataset.imageId === option.dataset.imageId && option.dataset.imageId);
        if (thumbnail) this.selectImage(thumbnail);
        if (!window.Shopify?.designMode) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
